<template>
<div class="contents">
  <admin adminType="staff"/>
</div>
</template>
<script>
import Admin from './../Admin/AdminOnetimePayment.vue'
export default {
  name: 'staff-onetime-payments',
  components: {
    Admin
  }
}
</script>